// pages/TwoFactorAuthPage.jsx
import React, { useState, useEffect } from 'react';
import { Form, Alert, Button, Typography, Layout, Input } from 'antd';
import AppHeader from '../components/AppHeader/AppHeader';
import { authService } from '../services/api';
import { useNavigate } from 'react-router-dom';

const { Title, Text } = Typography;
const { Content } = Layout;

const TwoFactorAuthPage = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const [tempUser, setTempUser] = useState(null);


    useEffect(() => {
        // Проверяем наличие временного токена
        if (!authService.isPending2FA()) {
            navigate('/login');
            return;
        }

        // Получаем данные временного пользователя
        const tempUserStr = localStorage.getItem('temp_user');
        if (tempUserStr) {
            setTempUser(JSON.parse(tempUserStr));
        } else {
            navigate('/login');
        }
    }, [navigate]);

    const onFinish = async (values) => {
        setLoading(true);
        setError('');

        const result = await authService.verify2FA(values.code);

        setLoading(false);

        if (result.success) {
            // Проверяем наличие сохраненных OAuth параметров
            const oauthParams = localStorage.getItem('oauth_params');

            // Если у пользователя временный пароль, перенаправляем его на страницу изменения пароля
            if (authService.hasTemporaryPassword()) {
                navigate('/change-temporary-password');
            } else if (oauthParams) {
                // Если есть OAuth параметры, перенаправляем на страницу OAuth
                navigate('/oauth/authorize', {
                    state: {
                        oauthParams: JSON.parse(oauthParams)
                    }
                });
            } else {
                // Стандартный редирект на главную
                navigate('/');
            }
        } else {
            setError(result.message);
            form.resetFields(['code']);
        }
    };

    const handleCancel = () => {
        authService.cancel2FA();
        navigate('/login');
    };

    return (
        <Layout style={{ minHeight: '100vh' }}>
            <AppHeader />
            <Content style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '24px' }}>
                <div style={{ width: '100%', maxWidth: '400px' }}>
                    <Title level={3} style={{ marginBottom: '16px' }}>
                        Двухфакторная аутентификация
                    </Title>

                    <Text style={{ display: 'block', marginBottom: '24px' }}>
                        Введите код из приложения
                    </Text>

                    {error && <Alert message={error} type="error" showIcon style={{ marginBottom: 24 }} />}

                    <Form
                        name="2fa_form"
                        onFinish={onFinish}
                        size="large"
                        layout="vertical"
                        form={form}
                    >
                        <Form.Item
                            name="code"
                            rules={[
                                { required: true, message: 'Пожалуйста, введите код' },
                                { len: 6, message: 'Код должен состоять из 6 цифр' }
                            ]}
                        >
                            <Input.OTP
                                length={6}
                                autoFocus
                                inputType="number"
                                inputStyle={{ width: '48px', height: '48px' }}
                            />
                        </Form.Item>

                        <Form.Item>
                            <Button
                                type="primary"
                                htmlType="submit"
                                loading={loading}
                                block
                            >
                                Войти
                            </Button>
                        </Form.Item>

                        <div style={{ textAlign: 'center' }}>
                            <Button
                                type="link"
                                onClick={handleCancel}
                            >
                                Отмена
                            </Button>
                        </div>
                    </Form>
                </div>
            </Content>
        </Layout>
    );
};

export default TwoFactorAuthPage;